module.exports = __webpack_public_path__ + "static/media/orthopaedicDevice.8e9a3204.svg";